<template>
  <div class="page">
    <c-source-form
      :columns="columns"
      :data="data"
      @submit="handleUpdate"
    >
      <ProductsPicker
        :selectedColorProductIdsProp="data.color_product_ids"
        ref="productsPickerForm"
      />
    </c-source-form>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import createColumns from './columns';
import _ from 'lodash';
import { DEFAULT_ORDER_BY } from '@/constants';
import ProductsPicker from './products-picker';

@Component({
  components: { ProductsPicker }
})
export default class TabmodulesEdit extends Vue {

  data = {}

  get columns() {
    return [
      ...createColumns(),
      {
        prop: 'default_order_by',
        label: '产品排序方式',
        form: {
          component: 'select',
          props: {
            options: _.map(DEFAULT_ORDER_BY, (label, value) => ({ label, value }))
          }
        }
      },
      {
        prop: 'first_color_product_id',
        label: '首个产品',
        form: {
          component: 'select',
          props: {
            options: [{
              label: _.get(this.data, 'first_color_product.name'),
              value: _.get(this.data, 'first_color_product.id')
            }].filter(item => item.value),
            clearable: true,
            xRemotePreload: async () => {
              const { data } = await this.$request.get(`/tab_modules/${this.$route.params.id}/color_products`, { params: { per_page: 99, page: 1 } })
              return _.map(data, p => ({ value: p.id, label: p.name }))
            },
            xRemoteSearch: async (keyword) => {
              const { data } = await this.$request.get(`/tab_modules/${this.$route.params.id}/color_products`, { params: { keyword: keyword } })
              return _.map(data, p => ({ value: p.id, label: p.name }))
            }
          }
        }
      }
    ]
  }

  async created() {
    this.data = await this.$request.get(`/tab_modules/${this.$route.params.id}`);
  }

  async handleUpdate(data) {
    const id = this.$route.params.id;
    const productsPickerForm = this.$refs.productsPickerForm.submit();
    await this.$autoLoading(
      this.$request.put(`/tab_modules/${id}`, { ...data, ...productsPickerForm })
    );
    this.$router.push({ name: 'tab_modules.show', params: { id } });
  }
}
</script>
